export const GET_ACTIVE_USERS_OVERVIEW = "getActiveUsersOverview";
export const GET_ACTIVITY_RESULTS = "getActivityResults";
export const GET_SKILLGAMES_USAGE = "getSkillgameUsage";
export const GET_SKILLGAMES_PERCENTAGE_USAGE = "getSkillgamesPercentageUsage";
export const GET_USER_OVERVIEW = "getUsersOveview";

//Home page
export const GET_ACTIVITY_PER_CATEGORY = "getActivityPerCategory";
export const GET_BOOKINGS_PER_CATEGORY = "getBookingsPerCategory";
export const GET_BOOKINGS_PER_FIELD = "getBookingsPerField";
export const GET_MOST_POPULAR_OVERVIEW = "getMostPopularOverview";
export const GET_BOOKINGS_OVERVIEW = "getBookingsOverview";
// SKILLCOURT SECTION

export const GET_USER_COURTS = "getUserCourts";
export const FETCH_FIELDS = "fetchFields";
export const FETCH_FIELDS_OVERVIEW = "fetchFieldsOverview";
